// The session shape today's suggestion is showing, shared between the Session
// tab and the Coach at rest (#109). Each view resolves its own preview with a
// random seed, so without this they could suggest different sessions, and
// Start in one could build a shape the other showed. The context string ties
// a choice to the day and the inputs; any change (a new day, a finished
// session, another session length) lets a fresh one be picked.

const KEY = "khronos_today_shape";
const EVENT = "khronos:today-shape";

export const todayShapeContext = ({ selector, minutes, sessionCount, date = new Date() }) =>
  [date.toDateString(), selector, minutes, sessionCount].join("|");

export const readTodayShape = (context) => {
  try {
    const stored = JSON.parse(localStorage.getItem(KEY) || "null");
    return stored?.context === context ? stored.archetypeId || null : null;
  } catch {
    return null;
  }
};

export const writeTodayShape = (context, archetypeId) => {
  try {
    if (archetypeId) localStorage.setItem(KEY, JSON.stringify({ context, archetypeId }));
    else localStorage.removeItem(KEY);
  } catch {
    /* storage blocked: each view keeps its own choice */
  }
  window.dispatchEvent(new Event(EVENT));
};

export const onTodayShapeChange = (handler) => {
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
};
